<template>
  <div id="app">
    <Navbar v-if="!$route.path.includes('/lockout')" />
    <NewSidebar v-if="getLoggedInUser.token" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <router-link :to="notificationLink">
      <notifications
        group="foo"
        position="bottom right"
        classes="my-style"
      />
    </router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NewSidebar from '@/components/sidebars/NewSidebar.vue';
import Navbar from '@/components/Navbar.vue';
import { client } from '@/domainConfig';
import eventBus from '@/main';
import getConnection from './microsoft-signalR/signalR';

export default {
  name: 'Home',
  components: {
    NewSidebar,
    Navbar,
  },
  data() {
    return {
      client: client.clientName,
      notificationLink: '',
      notificationCount: 0,
      logoutTimer: null,
      test: process.env.VUE_APP_REGION,
      showModal: false,
      birthdayNotification: '',
      screenWidth: window.innerWidth,
      refreshTokenInterval: null,
    };
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'getLoadingStates', 'getIsLoading', 'getUsers']),
    isAnyRequestLoading() {
      return Object.values(this.getLoadingStates).includes(true);
    },
  },
  watch: {
    /* eslint-disable-next-line object-shorthand */
    /*     'getLoggedInUser.token'(newToken) {
      if (newToken) {
        this.startRefreshTokenInterval(this.$router);
      }
    }, */
  },
  created() {
    eventBus.$on('logout-triggered', this.handleGlobalLogout);
    if (!this.getLoggedInUser.token) {
      this.$router.push('/login');
    } else {
      this.$nextTick(() => {
      });
    }
  },
  mounted() {
    if (this.getLoggedInUser?.storeId) {
      this.loadMaterialVariants();
      this.resetAllLoadingStatesToFalse();
      this.loadArticlesInCart({
        storeId: this.getLoggedInUser.storeId,
        orderState: 'Pending',
        pageNumber: 1,
        pageSize: 5,
      });
    }

    /*     if (this.getLoggedInUser?.token) {
      this.startRefreshTokenInterval(this.$router);
    } */

    const connection = getConnection();
    if (connection.state === 'Connected') {
      console.log('SignalR already connected');
    } else {
      connection.start()
        .then(() => { return console.log('SignalR connection started in App.vue') })
        .catch((err) => { return console.error('SignalR connection error:', err) });
    }

    // events that are triggered
    // connection.on('sendNotificationCounter', this.handleNotification);
    // connection.on('sendCreateNewOrderNotificationAlert', this.handleOrders);
  },
  beforeDestroy() {
    eventBus.$off('logout-triggered', this.handleGlobalLogout);

    // Clear the interval to avoid memory leaks
    // if (this.refreshTokenInterval) {
    //   clearInterval(this.refreshTokenInterval);
    // }
    // const connection = getConnection();
    // connection.off('sendNotificationCounter', this.handleNotification);
    // connection.off('sendCreateNewOrderNotificationAlert', this.handleOrders);
  },
  methods: {
    ...mapActions([
      'logoutUser',
      'changeLanguage',
      'changeVisibilityOfSidebar',
      'incrementNotificationCount',
      'changeLoadingtoTrue',
      'getUsersPagination',
      'getMaterialVariantsToMDCPagination',
      'resetAllLoadingStatesToFalse',
      'loadArticlesInCart',
      'refreshToken',
      'startRefreshTokenInterval',
    ]),
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    loadMaterialVariants() {
      const measurements = ['Meter', 'Package', 'Set', 'Pair', 'Verse', 'Part', 'Meter_Square'];
      measurements.forEach((measurement) => {
        this.getMaterialVariantsToMDCPagination({ pageNumber: 1, pageSize: 15, measurement });
      });
    },
    handleGlobalLogout() {
      this.logoutUser()
    },
    logout() {
      this.logoutUser();
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "DM Sans";
  src: local("DMSans"),
    url(../src/assets/fonts/DMSans-Regular.ttf) format("truetype");
}
</style>
